import { Component, PropsWithChildren, ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface IMapControlProps {
  map: any;
  controlPosition: number | null;
}

export class MapControl extends Component<PropsWithChildren<IMapControlProps>> {
  private el = document.createElement('div');
  private addedToMap = false;

  componentDidMount(): void {
    this.addControlToMap();
  }

  componentDidUpdate(): void {
    this.addControlToMap();
  }

  shouldComponentUpdate(nextProps: IMapControlProps): boolean {
    return !this.props.map && !!nextProps.map;
  }

  componentWillUnmount(): void {
    const { map, controlPosition } = this.props;

    if (!map || controlPosition === null) {
      return;
    }

    const index = map.controls[controlPosition].getArray().indexOf(this.el);

    map.controls[controlPosition].removeAt(index);
  }

  addControlToMap(): void {
    const { map, controlPosition } = this.props;

    if (!map || controlPosition === null || this.addedToMap) {
      return;
    }

    map.controls[controlPosition].push(this.el);
    this.addedToMap = true;
  }

  render(): ReactNode {
    const { map, controlPosition } = this.props;

    if (!map || controlPosition === null) {
      return null;
    }

    return createPortal(this.props.children, this.el);
  }
}
